<mat-card class="mat-elevation-z0">
    <mat-card-title appLocalizationPopupDirective localizationCode="QuickLinks">
        {{ 'QuickLinks' | translate: {Default: "Quick Links"} }}
    </mat-card-title>

    <mat-card-content>
        <div *ngIf="loading" class="loading-container">
            <ngx-skeleton-loader
                    count="5"
                    appearance="circle"
                    [theme]="{
                    'height.px': 50,
                    'width.px': 50
                    }">
                </ngx-skeleton-loader>
        </div>

        <div *ngIf="!loading">
            <div class="quick-links-container">
                <div *ngIf="quickLinks.length === 0" appLocalizationPopupDirective localizationCode="NoQuickLinks">
                    {{ 'NoQuickLinks' | translate: {Default: "No quick links available."} }}
                </div>

                <div *ngIf="quickLinks.length > 0" class="quick-links-list">
                    <div 
                        *ngFor="let link of quickLinks" 
                        appPreventDoubleClick (throttledClick)="openQuickLink(link)" 
                        class="quick-link"
                    >
                        <mat-icon class="quick-links-icon material-icons-outlined">{{ link.icon }}</mat-icon>
                        <div class="title">{{ link.title }}</div>
                        <div class="description">{{ link.description }}</div>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>